module.exports = __webpack_public_path__ + "img/LOGO_RACE-01.98846898.png";